import React from 'react'

export default (props) =>
  <div className='btn btn-default' onClick={() => props.onClick()}>
    New Game
  </div>



// WEBPACK FOOTER //
// ./src/components/NewGame.js